exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heroicon-chat .heroicon-outline{fill:#303034}.heroicon-chat .heroicon-component-fill{fill:#fff}.heroicon-chat .heroicon-component-accent{fill:#919495}.heroicon-chat .heroicon-shadows{fill:#303034;opacity:.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9e5360b6","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Icons/ChatIcon.vue
// module id = oD1X
// module chunks = 0